import React from 'react'
import { getStartEndDate } from '../../../../../helpers/getStartEndDate';
import { numberFormat } from '../../../../../helpers/numberFormat';
import { getTotalParticipantProgram } from '../../../../../helpers/getTotalParticipantProgram';

const FiveRincianPembayaranCorporate = (props) => {

    // console.log(props)

    return (
        <>
            <div className='row' style={{ marginLeft: '5px', marginTop: props.size.width < 500 ? '10%' : '0%' }}>
                <h5 style={{ color: '#26D07C', marginBottom: '3%', fontSize: '16px', fontWeight: '700' }}>Rincian Pembayaran</h5>
                <div className='col-lg-12'>
                    <div className="card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr className="text-gray-800 border-bottom border-gray-200">
                                            <th className='text-center'>Nama Program</th>
                                            <th className='text-center'>Jadwal Program</th>
                                            <th className='text-center'>Harga</th>
                                            <th className='text-center'>Jumlah Peserta</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            props.programSelected.map((program, j) =>
                                                <>
                                                    <tr className="fw-bold  text-gray-800 border-bottom border-gray-200">
                                                        <td>{program.name}</td>
                                                        <td>{getStartEndDate(props.scheduleSelected, program.id)}</td>
                                                        <td>Rp. {numberFormat(program?.Pricebooks[0].price)}</td>
                                                        <td className='text-center'>{getTotalParticipantProgram(props.participants, program.id)}</td>
                                                    </tr>
                                                    <tr className="fw-bold  text-gray-800 border-bottom border-gray-200">
                                                    </tr>
                                                </>
                                            )
                                        }

                                        {
                                            props.bpSelected.map((bp, j) =>
                                                <>
                                                    <tr className="fw-bold  text-gray-800 border-bottom border-gray-200">
                                                        <td>{bp.name}</td>
                                                        <td>Bundling</td>
                                                        <td>Rp. {numberFormat(bp.price)}</td>
                                                        <td className='text-center'>{props.bpParticipants.length}</td>
                                                    </tr>
                                                    <tr className="fw-bold  text-gray-800 border-bottom border-gray-200">
                                                    </tr>
                                                </>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FiveRincianPembayaranCorporate
